
  import Vue from 'vue'
  import Component from 'vue-class-component'
  import { Prop } from 'vue-property-decorator'
  import { IServiceProvider } from '@/model/Service/serviceProviderInterfaces'
  import { IErrors } from '@/model/IErrors'

  @Component({})
  export default class SPSubscriptionSettings extends Vue {

    @Prop() protected provider!: IServiceProvider
    @Prop() protected errors!: IErrors
    @Prop() protected editing!: boolean
    @Prop() protected viewing!: boolean
    @Prop() protected disabled!: boolean

    created() {
      this.provider.subscription_enabled = this.provider.subscription_enabled || false
    }

    // ── Header icon styles (primary-tinted) ─────────────────────

    protected get primaryColor(): string {
      const v = this.$vuetify
      return (v && v.theme && v.theme.currentTheme && (v.theme.currentTheme.primary as string)) || '#1976D2'
    }

    protected get headerIconWrapStyle(): object {
      return { background: this.primaryColor }
    }

    protected get headerIconStyle(): object {
      return { color: '#fff' }
    }

    protected get iconBoxStyle(): object {
      return { background: this.primaryColor + '18' }
    }

    protected get iconStyle(): object {
      return { color: this.primaryColor }
    }

    // ── First billing date preview ───────────────────────────────

    protected get firstBillingPreview(): string | null {
      const anchorDay = this.provider.billing_anchor_day
      if (!anchorDay) return null

      const today = new Date()
      const cutoffDay = this.provider.billing_cutoff_day !== null && this.provider.billing_cutoff_day !== undefined
        ? this.provider.billing_cutoff_day
        : null
      const todayDay = today.getDate()

      let billingDate: Date

      if (todayDay < anchorDay) {
        billingDate = new Date(today.getFullYear(), today.getMonth(), anchorDay)
      } else if (cutoffDay === null || todayDay <= cutoffDay) {
        billingDate = new Date(today.getFullYear(), today.getMonth() + 1, anchorDay)
      } else {
        const cycles = this.provider.billing_cycles_after_cutoff || 2
        billingDate = new Date(today.getFullYear(), today.getMonth() + cycles, anchorDay)
      }

      const locale = (this.$i18n && this.$i18n.locale) || 'es'
      return billingDate.toLocaleDateString(locale, {
        day: 'numeric',
        month: 'long',
        year: 'numeric',
      })
    }

    // ── Select item lists ────────────────────────────────────────

    protected get billingDayItems(): number[] {
      return Array.from({ length: 28 }, (_, i) => i + 1)
    }

    protected get cyclesAfterCutoffItems(): { text: string; value: number }[] {
      return Array.from({ length: 5 }, (_, i) => {
        const n = i + 1
        return { text: String(n), value: n }
      })
    }

    protected get prorationBehaviorItems(): { text: string; value: string }[] {
      const values: any = this.$t('services.provider.fields.subscription_proration_behavior_values')
      return Object.keys(values).map(key => ({ text: values[key], value: key }))
    }

    protected get collectionMethodItems(): { text: string; value: string }[] {
      const values: any = this.$t('services.provider.fields.subscription_collection_method_values')
      return Object.keys(values).map(key => ({ text: values[key], value: key }))
    }

    protected get trialEndBehaviorItems(): { text: string; value: string }[] {
      const values: any = this.$t('services.provider.fields.subscription_trial_end_behavior_values')
      return Object.keys(values).map(key => ({ text: values[key], value: key }))
    }

    protected get paymentBehaviorItems(): { text: string; value: string }[] {
      const values: any = this.$t('services.provider.fields.subscription_payment_behavior_values')
      return Object.keys(values).map(key => ({ text: values[key], value: key }))
    }
  }
